


















































































































































import { Component, Vue } from "vue-property-decorator";
import { Withdraw, Wallet } from "@/interfaces";
import {
  dispatchGetWithdraws,
  dispatchConfirmWithdraw,
  dispatchGetWithdrawStates,
  dispatchRevertWithdraw
} from "@/store/main/actions";
import { readOneWithdraw, readWithdrawStateName } from "@/store/main/getters";
import { readUserOneWallet, readCurrencyName } from "@/store/wallet/getters";
import {
  dispatchGetWallets,
  dispatchGetCurrencies
} from "@/store/wallet/actions";

@Component
export default class SettleWithdraw extends Vue {
  public valid = true;
  public loading = true;
  public withdraw: Withdraw | null = null;
  public wallet_: Wallet | null = null;
  public TYPE_TRANSFER = 1;
  public TYPE_WITHDRAW = 2;
  public type = this.TYPE_WITHDRAW;

  public async mounted() {
    this.loading = true;
    await Promise.allSettled([
      dispatchGetWithdraws(this.$store),
      dispatchGetWallets(this.$store),
      dispatchGetWithdrawStates(this.$store),
      dispatchGetCurrencies(this.$store)
    ]);
    const withdraw = readOneWithdraw(this.$store)(
      +this.$router.currentRoute.params.id
    );

    console.log(withdraw)
    if (withdraw) this.withdraw = withdraw;
    const wallet_id = this.withdraw?.to_wallet_id;
    if (wallet_id) {
      const wallet = readUserOneWallet(this.$store)(wallet_id);
      if (wallet) this.wallet_ = wallet;
      this.type = this.TYPE_WITHDRAW;
    }else{
      this.type = this.TYPE_TRANSFER;
    }




    this.loading = false;
  }

  public async cancel() {
    await dispatchRevertWithdraw(this.$store, {
      id: this.withdraw!.id
    });
    this.$router.back();
  }

  public async submit() {
    if (await this.$validator.validateAll()) {
      await dispatchConfirmWithdraw(this.$store, {
        id: this.withdraw!.id
      });
      this.$router.push({
        name: "main-withdraw-view"
      });
    }
  }

  get from_amount() {
    const amount = this.withdraw?.from_amount;

    if (!this.withdraw?.currency) return "----";
    const currency = readCurrencyName(this.$store)(this.withdraw?.currency);

    if (currency === "IRT") {
      if (amount) return (+amount.toFixed(0)).toLocaleString() + "تومان";
    } else if (currency === "ETH") {
      if (amount) return (amount / 10 ** 18).toFixed(5) + "ETH";
    }else if (currency === "ETC") {
      if (amount) return (amount / 10 ** 18).toFixed(5) + "ETC";
    }else if (currency === "ZIL") {
      if (amount) return (amount / 10 ** 12).toFixed(5) + "ZIL";
    }else if (currency === "XCH") {
      if (amount) return (amount / 10 ** 12).toFixed(5) + "XCH";
    }else if (currency === "XCC") {
      if (amount) return (amount / 10 ** 8).toFixed(5) + "XCC";
    }
    return "----";
  }

  get to_amount() {

    let currency;
    if(this.type == this.TYPE_WITHDRAW){
      if (!this.wallet_ || !this.wallet_?.currency) return "----";
      currency = readCurrencyName(this.$store)(this.wallet_?.currency);
    }else {
      if (!this.withdraw?.currency) return "----";
      currency = readCurrencyName(this.$store)(this.withdraw?.currency);
    }


    const amount = this.withdraw?.to_amount;
    if (currency === "IRT") {
      if (amount) return (+amount.toFixed(0)).toLocaleString() + "تومان";
    } else if (currency === "ETH") {
      if (amount) return (amount / 10 ** 18).toFixed(5) + "ETH";
    }else if (currency === "ETC") {
      if (amount) return (amount / 10 ** 18).toFixed(5) + "ETC";
    }else if (currency === "ZIL") {
      if (amount) return (amount / 10 ** 12).toFixed(5) + "ZIL";
    }else if (currency === "XCH") {
      if (amount) return (amount / 10 ** 12).toFixed(5) + "XCH";
    }else if (currency === "XCC") {
      if (amount) return (amount / 10 ** 8).toFixed(5) + "XCC";
    }
    return "----";
  }

  get wallet() {
    if (!this.wallet_) return "----";
    return `${this.wallet_.id}/${this.wallet_.owner_id}/${this.wallet_.name}/${this.wallet_.currency}/${this.wallet_.address}`;
  }

  get currency() {
    if (!this.wallet_ || !this.withdraw?.currency) return "----";
    return `${readCurrencyName(this.$store)(
      this.withdraw?.currency
    )}->${readCurrencyName(this.$store)(this.wallet_?.currency)}`;
  }

  get is_eth() {
    return readCurrencyName(this.$store)(this.wallet_!.currency) === "ETH";
  }

  get state() {
    const state_id = readOneWithdraw(this.$store)(
      +this.$router.currentRoute.params.id
    )?.state;
    if (!state_id) return "----";
    return readWithdrawStateName(this.$store)(state_id);
  }

  public getColor() {
    if (this.state === "COMPLETED" || this.state === "MANUAL_SETTLEMENT")
      return "color:green";
    else if (this.state === "REJECTED" || this.state === "FAILED")
      return "color:red";
    return "color:blue";
  }
}
